import React, { useEffect, useState } from 'react';
import '../../App.css';
import styled from 'styled-components';

const Localtime = styled.div`
  min-width: 150px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 5px;
  
  // @media (max-width: 768px) {
  //   width: 100%;
  //   align-items: center;
  //   margin: 0 0 5px 0;
  //   padding: 0.5rem 0;
  //   border: 1px solid ${({ theme }) => theme.text};
  //   }
`;

const LocalTime: React.FC = () => {
  const [localTime, setLocalTime] = useState<string>('');

  useEffect(() => {
    const updateLocalTime = () => {
      const now = new Date();
      const formattedTime = new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        // second: '2-digit',
        hour12: true,
        timeZoneName: 'short'
      }).format(now);
      setLocalTime(formattedTime);
    };

    updateLocalTime();
    const interval = setInterval(updateLocalTime, 1000);

    return () => clearInterval(interval);
  }, []); 

  return (
    <Localtime >
      <div style={{fontSize: '11px'}}>Local Time</div>
      <div style={{fontSize: '14px'}}>{localTime}</div>
    </Localtime >
  );
};

export default LocalTime;